import axios from 'axios';

export const validateUser = async (code, companyId, multidomain) => {
  const params = {
    code
  };
  if (companyId) {
    params.companyId = companyId;
  }
  if (multidomain) {
    params.multidomain = multidomain;
  }
  const { data } = await axios.post('/users/validate', params);

  return data;
};
